import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function ProductionPlanMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Gantt Chart: Kế hoạch Sản xuất T2/2026
        </span>
        <div className="flex gap-1">
          <span className="px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded text-[9px] font-medium border border-indigo-200">
            In Offset
          </span>
          <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-[9px] font-medium border border-slate-200">
            Bế
          </span>
          <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-[9px] font-medium border border-slate-200">
            Dán
          </span>
        </div>
      </div>
      <div className="p-3 flex-1 flex flex-col overflow-hidden">
        {/* Gantt Header */}
        <div className="flex bg-slate-100 border border-slate-200 rounded-t text-[9px] md:text-[10px] text-slate-500 font-medium">
          <div className="w-24 md:w-32 p-1.5 border-r border-slate-200 shrink-0">
            Máy / Ca
          </div>
          <div className="flex-1 grid grid-cols-6 divide-x divide-slate-200">
            <div className="p-1.5 text-center">T2 (25/5)</div>
            <div className="p-1.5 text-center bg-indigo-50 text-indigo-600 font-bold">
              T3 (26/5) - Hiện tại
            </div>
            <div className="p-1.5 text-center">T4 (27/5)</div>
            <div className="p-1.5 text-center">T5 (28/5)</div>
            <div className="p-1.5 text-center">T6 (29/5)</div>
            <div className="p-1.5 text-center text-red-500">T7 (30/5)</div>
          </div>
        </div>

        {/* Gantt Body */}
        <div className="flex-1 overflow-auto border-x border-b border-slate-200 rounded-b">
          {/* Máy In 1 */}
          <div className="flex border-b border-slate-100 text-[9px] md:text-xs">
            <div className="w-24 md:w-32 p-2 border-r border-slate-100 bg-slate-50 font-medium text-slate-700 flex flex-col justify-center shrink-0">
              Komori 4 Màu
            </div>
            <div className="flex-1 grid grid-cols-6 relative">
              <div className="col-span-6 grid grid-cols-6 divide-x divide-slate-100 absolute inset-0 pointer-events-none">
                <div></div>
                <div className="bg-indigo-50/30 border-x-2 border-indigo-200"></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="col-span-6 relative p-1.5 h-10">
                {/* Task 1 */}
                <div className="absolute left-[5%] right-[70%] top-2 bottom-2 bg-indigo-500 rounded text-white text-[8px] md:text-[9px] flex items-center px-2 shadow-sm truncate overflow-hidden">
                  PO-120: Hộp Yến
                </div>
                {/* Task 2 (Current) */}
                <div className="absolute left-[35%] right-[40%] top-2 bottom-2 bg-emerald-500 rounded text-white text-[8px] md:text-[9px] flex items-center px-2 shadow-sm border-2 border-emerald-300 z-10 truncate overflow-hidden">
                  PO-089: Hộp Mỹ Phẩm (Đang in)
                </div>
              </div>
            </div>
          </div>
          {/* Máy In 2 */}
          <div className="flex border-b border-slate-100 text-[9px] md:text-xs">
            <div className="w-24 md:w-32 p-2 border-r border-slate-100 bg-slate-50 font-medium text-slate-700 flex flex-col justify-center shrink-0">
              Heidelberg 6 Màu
            </div>
            <div className="flex-1 grid grid-cols-6 relative">
              <div className="col-span-6 grid grid-cols-6 divide-x divide-slate-100 absolute inset-0 pointer-events-none">
                <div></div>
                <div className="bg-indigo-50/30 border-x-2 border-indigo-200"></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="col-span-6 relative p-1.5 h-10">
                {/* Task 3 */}
                <div className="absolute left-[20%] right-[10%] top-2 bottom-2 bg-indigo-200 text-indigo-900 border border-indigo-300 rounded text-[8px] md:text-[9px] flex items-center px-2 truncate overflow-hidden">
                  PO-095: Tem nhãn Decal (Chờ kẽm)
                </div>
              </div>
            </div>
          </div>
          {/* Máy Bế */}
          <div className="flex border-b border-slate-100 text-[9px] md:text-xs">
            <div className="w-24 md:w-32 p-2 border-r border-slate-100 bg-slate-50 font-medium text-slate-700 flex flex-col justify-center shrink-0">
              Máy Bế Tự Động
            </div>
            <div className="flex-1 grid grid-cols-6 relative">
              <div className="col-span-6 grid grid-cols-6 divide-x divide-slate-100 absolute inset-0 pointer-events-none">
                <div></div>
                <div className="bg-indigo-50/30 border-x-2 border-indigo-200"></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="col-span-6 relative p-1.5 h-10">
                {/* Task 4 (Depends on Task 2) */}
                <div className="absolute left-[65%] right-[20%] top-2 bottom-2 bg-orange-400 text-white rounded text-[8px] md:text-[9px] flex items-center px-2 shadow-sm truncate overflow-hidden">
                  PO-089 (Bế)
                </div>
                {/* Dependency Arrow mock */}
                <div className="absolute left-[60%] top-[-10px] w-5 h-5 border-l-2 border-b-2 border-slate-400 rounded-bl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-50">
      <div className="bg-white p-3 border-b border-slate-200 z-10 sticky top-0 shadow-sm flex flex-col items-center">
        <div className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">
          Máy In Komori - Ca Ngày
        </div>
        <div className="flex bg-slate-100 p-1 rounded-lg w-full">
          <button className="flex-1 text-[10px] py-1 bg-white rounded shadow text-slate-800 font-bold">
            Chờ làm
          </button>
          <button className="flex-1 text-[10px] py-1 text-slate-500 font-medium">
            Hoàn thành
          </button>
        </div>
      </div>

      <div className="flex-1 p-3 overflow-y-auto space-y-3">
        {/* Active Task */}
        <div className="bg-emerald-50 border-2 border-emerald-500 rounded-xl p-3 shadow-sm relative">
          <div className="absolute top-0 right-0 bg-emerald-500 text-white text-[9px] font-bold px-2 py-0.5 rounded-bl-lg">
            ĐANG CHẠY
          </div>
          <div className="text-xs font-bold text-emerald-900 mb-1">
            #PO-089: Hộp Mỹ Phẩm
          </div>
          <div className="text-[10px] text-emerald-700 mb-2">
            Số lượng: 10,100 tờ | Khổ: 79x109
          </div>
          <div className="flex justify-between items-center bg-white p-2 rounded-lg border border-emerald-100 mt-2">
            <div className="text-[10px] text-slate-600">
              Giấy đã cấp:{" "}
              <span className="font-bold text-slate-800">100%</span>
            </div>
            <div className="text-[10px] text-slate-600">
              Kẽm: <span className="font-bold text-slate-800">Đã nhận</span>
            </div>
          </div>
        </div>

        {/* Queue Task 1 */}
        <div className="bg-white border border-slate-200 rounded-xl p-3 shadow-sm opacity-80">
          <div className="flex justify-between items-start mb-1">
            <div className="text-xs font-bold text-slate-800">
              #PO-095: Tem nhãn Decal
            </div>
            <div className="text-[9px] font-medium text-amber-600 bg-amber-50 px-1 rounded border border-amber-100">
              Chờ Kẽm
            </div>
          </div>
          <div className="text-[10px] text-slate-500">
            Số lượng: 2,500 tờ | Khổ: 65x86
          </div>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
